"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_decorators_1 = require("lodash-decorators");
exports.default = lodash_decorators_1.memoize;



//////////////////
// WEBPACK FOOTER
// ./~/@shopify/javascript-utilities/decorators/memoize.js
// module id = ./node_modules/@shopify/javascript-utilities/decorators/memoize.js
// module chunks = 0